/**
 * Scroll-Wiederherstellung für asynchron ladende Listen (Regel „Dokument-Navigation"
 * R2). Die Wiederherstellung des Routers läuft, bevor die Liste geladen ist — die Seite
 * ist dann zu kurz. Reine Rechenfunktion; der Hook dazu liegt in useScrollRestore.ts.
 */
export interface ScrollAttempt {
  /** Position, die jetzt angefahren wird */
  y: number;
  /** true = Ziel erreicht oder nichts zu tun */
  done: boolean;
}

export function nextScrollAttempt(targetY: number, docHeight: number, viewportH: number): ScrollAttempt {
  const target = Math.max(0, Math.round(targetY));
  if (target === 0) return { y: 0, done: true };
  const maxY = Math.max(0, Math.round(docHeight - viewportH));
  if (maxY >= target) return { y: target, done: true };
  // Seite noch zu kurz: so weit wie möglich, später erneut versuchen.
  return { y: maxY, done: false };
}
